module.exports = __webpack_public_path__ + "media/images/logo-6cbf930331794f9fbc54cd9f7339ff9e.png";